import AbstractViewManage from '@/class/view/AbstractViewManage'
import ColumnUtils from '@/utils/ColumnUtils'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { queryBillPaymentList, batchUpdateBilPaymentStatePrintMsg, batchDelBillPayment } from '@/api/clearing/billPayment'
import * as NumberUtils from '@/utils/NumberUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default class billingPaymentHp extends AbstractViewManage {
  constructor(view) {
    super(view)
  }

  created() {
    const isChinese = this.$store.getters.language === 'zh'
    this._view.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('Payment.applicationNo'),
        field: 'billPaymentNo'
      },
      {
        headerName: this.$t('Payment.approveHistoryNode'),
        field: 'approveNode'
      },
      {
        headerName: this.$t('Payment.settleAccountsTo'),
        field: isChinese ? 'accountChineseName' : 'accountEnglishName'
      },
      {
        headerName: this.$t('Payment.settlementAgent'),
        field: isChinese ? 'settlementAgentChineseName' : 'settlementAgentEnglishName'
      },
      {
        headerName: this.$t('Payment.consignationCompany'),
        field: isChinese ? 'customerChineseName' : 'customerEnglishName'
      },
      {
        headerName: this.$t('Payment.businessNumber'),
        field: 'jobNo',
        cellRenderer: params => {
          return params.value
          // const methodPath = this._view.documentManage.getPath('toSearchTemplate')
          // return `<a href="/" style="color:#0052cc;">${params.value}</a>
          //       <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
        }
      },
      {
        headerName: this.$t('Payment.dateOfApplication'),
        field: 'inputDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('Payment.applicant'),
        field: isChinese ? 'inputByChineseName' : 'inputByEnglishName'
      },
      {
        headerName: this.$t('Payment.applicationDepartment'),
        field: isChinese ? 'inputByDepChineseName' : 'inputByDepEnglishName'
      },
      {
        headerName: this.$t('Payment.paymentPeriod'),
        field: 'deadline',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('Payment.methodOfPayment'),
        field: 'payType',
        cellRenderer: (params) => {
          return ColumnUtils.amountReceiveTypeLabelFun(params.value)
        }
      },
      {
        headerName: this.$t('Payment.currency'),
        field: 'currency'
      },
      {
        headerName: this.$t('Payment.amount'),
        field: 'amount',
        cellRenderer: (params) => {
          return NumberUtils.formatRoundNumber(params.value, 2)
        }
      },
      // {
      //   headerName: this.$t('Payment.theAmountOfWriteOffs'),
      //   field: 'verifiedAmount',
      //   cellRenderer: (params) => {
      //     return params.value === 0 ? '' : NumberUtils.formatRoundNumber(params.value, 2)
      //   }
      // },
      {
        headerName: this.$t('Payment.currencyAmountOfWriteOffs'), field: 'currencyVerifiedAmount'
      },
      {
        headerName: this.$t('WriteOff.approvalStatus'),
        field: 'state',
        cellRenderer: (params) => {
          return ColumnUtils.billPaymentStateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('WriteOff.businessAuditor'),
        field: isChinese ? 'businessVerifierChineseName' : 'businessVerifierEnglishName'
      },
      {
        headerName: this.$t('WriteOff.businessAuditDate'),
        field: 'businessVerifyDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('WriteOff.financialAuditor'),
        field: isChinese ? 'financeVerifierChineseName' : 'financeVerifierEnglishName'
      },
      {
        headerName: this.$t('WriteOff.financialAuditDate'),
        field: 'financeVerifyDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('WriteOff.verificationStatus'),
        field: 'realClearingState',
        cellRenderer: (params) => {
          return ColumnUtils.clearingStateLabFun(params.value)
        }
      },
      {
        headerName: this.$t('Payment.remarks'),
        field: 'remark'
      },
      {
        headerName: this.$t('Payment.totalCurrency'),
        field: 'currencyAmount'
      },
      {
        headerName: this.$t('WriteOff.proofNo'),
        field: 'voucherNo'
      },
      {
        headerName: this.$t('WriteOff.voucherCreateDate'),
        field: 'voucherCreateDate',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('WriteOff.targetVoucherNo'),
        field: 'targetVoucherNo2Charge'
      },
      {
        headerName: this.$t('Payment.invoice_voucherDate'),
        field: 'voucherDate2Charge'
      },
      {
        headerName: this.$t('queryJob.placeOfDelivery'),
        field: 'destinationPlace',
        colId: 'destinationPlace',
        width: 200,
        hide: true
      },
      {
        headerName: this.$t('Payment.mbl'),
        field: 'mbl',
        width: 200,
        cellRendererFramework: 'CargoGridShowBigContent',
        tooltipValueGetter: () => {},
        hide: true
      }
    ]
    this._view.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      context: {
        componentParent: this
      },
      defaultColDef: {
        resizable: true,
        filter: true
      },
      onRowDoubleClicked: this._view.rowDoubleClicked,
      pagination: false
    }
  }

  beforeMount() {
    const context = this
    this._view.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
  }
  // 刷新一条数据
  refreshOneBuyKey(conditions) {
    const requestBody = { conditions, branchId: this.$store.getters.currentOfficeId }
    this.loading()
    queryBillPaymentList(requestBody).then(res => {
      if (res.data.list.length > 0) {
        const data = [... this._view.rowData]
        for (let i = 0; i < data.length; i++) {
          console.log(this._view.rowData[i].uuid)
          if (data[i].uuid === res.data.list[0].uuid) {
            data[i] = res.data.list[0]
            break
          }
        }
        this._view.rowData = data
      }
    }).finally(() => {
      this.closeLoading()
    })
  }
  // 查询
  doSearch() {
    this._view.rowData = []
    const { snapshotConditions: conditions, requires, pageNum, pageSize } = this._view.searchConditions
    const requestBody = { conditions, requires, pageNum, pageSize, branchId: this.$store.getters.currentOfficeId }
    this.loading()
    const selectedStatus = recordSelectedStatus(this._view.gridOptions.api, 'uuid')
    queryBillPaymentList(requestBody).then(res => {
      this._view.rowData = res.data.list
      this._view.searchConditions.total = Number(res.data.total)
      selectedStatus.revert()
    }).finally(() => {
      this.closeLoading()
    })
  }
  // 查看付款申请(doubleClick是否通过双击列查看,rowDataSelected只在双击时有数据)
  viewBillPaymentDetail(doubleClick = false, rowDataSelected) {
    let uuid = ''
    if (doubleClick) {
      if (rowDataSelected['branchId'] !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(rowDataSelected['branchId'])) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      uuid = rowDataSelected['uuid']
      this._view.billPaymentDetailProperties.state = rowDataSelected['state']
      this._view.billPaymentDetailProperties.inputBy = rowDataSelected['inputBy']
    } else {
      const chooseRows = getGridSelected(this._view.gridOptions)
      if (chooseRows.length !== 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }
      const billPayment = chooseRows[0]
      if (billPayment.branchId !== this.$store.getters.currentOfficeId && !JobUtils.checkHierarchicalDetailFinancial(billPayment.branchId)) {
        this.$message.warning(this.$t('Message.NoHasViewRole'))
        return
      }
      uuid = billPayment['uuid']
      this._view.billPaymentDetailProperties.state = billPayment['state']
      this._view.billPaymentDetailProperties.inputBy = billPayment['inputBy']
    }
    if (uuid) {
      this._view.billPaymentDetailProperties.uuid = uuid
      this._view.billPaymentDetailProperties.visible = true
      this._view.billPaymentDetailProperties.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
    }
  }
  // 收票
  collectInvoice() {
  }
  // 创建付款申请第一步
  createBillPayment() {
    this._view.createNewDialog.visible = true
    this._view.createNewDialog.title = this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees')
    this._view.createNewDialog.source = 'newPayment'
  }
  // 创建付款申请第二步
  createBillPaymentNext(data) {
    // 隐藏创建弹窗
    this._view.createNewDialog.visible = false
    // 展示详情弹窗
    this._view.billPaymentDetailProperties.visible = true
    this._view.billPaymentDetailProperties.title = '创建付款申请-详细信息'
    console.log('rowDataSelected--------------', this._view.billPaymentDetailProperties)
    this._view.billPaymentDialog.visible = true
    this._view.billPaymentDialog.params = { mode: 2, data: { ...data }}
  }
  // 删除付款申请
  deleteBillPayment() {
    const chooseRows = getGridSelected(this._view.gridOptions)
    if (chooseRows.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PSPATD'))
      return
    }
    // 确少判付款申请状态
    // 确认删除么
    this.$confirm(this.$t('CargoMsg.Cargo_STDTPA'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(async() => {
      console.log(chooseRows)
      this.loading()
      const billPayments = []
      for (let i = 0; i < chooseRows.length; i++) {
        const selectItem = {}
        selectItem.uuid = chooseRows[i].uuid
        selectItem.version = chooseRows[i].version
        billPayments.push(selectItem)
      }
      batchDelBillPayment(billPayments, this._view.location).then(res => {
        if (res.data === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DeleteFailed'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        }
        this.doSearch()
      }).finally(() => {
        this.closeLoading()
      })
    })
  }
  // 提交付款申请
  commitBillPayment(state) {
    this._view.canSendWeaver = true
    const chooseRows = getGridSelected(this._view.gridOptions)
    if (chooseRows.length === 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PSPATS'))
      this._view.canSendWeaver = false
      return
    } else if (chooseRows.length > 1) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectAnBillPayment'))
      return
    }
    const billPayment = {
      state: state,
      inputDate: chooseRows[0].inputDate,
      currency: chooseRows[0].currency,
      billPayments: []
    }
    for (let i = 0; i < chooseRows.length; i++) {
      const selectItem = {}
      selectItem.uuid = chooseRows[i].uuid
      selectItem.version = chooseRows[i].version
      billPayment.billPayments.push(selectItem)
    }
    this.loading()
    batchUpdateBilPaymentStatePrintMsg(billPayment).then(res => {
      if (res.data.code === 0) {
        this.$message.warning(res.data.msg)
        this._view.canSendWeaver = false
      } else {
        this.$message.success(res.data.msg)
        this.doSearch()
        this._view.canSendWeaver = false
      }
    }).finally(() => {
      this.closeLoading()
      this._view.canSendWeaver = false
    })
  }
}
